export const ExchangeCalendarHowItWorks: React.FC = () => {
  return (
    <div>
      Connect your on-premise Exchange Calendar to give Zocks access to your meeting schedule. Once connected, Zocks automatically syncs your upcoming meetings
      and can join them without manual invitation.
    </div>
  )
}
